import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWan30AiVideoGeneratorConfig } from '@/data/landingConfig/landingWan30AiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Wan30AiVideoGenerator } from './schemaObject';

interface Props {}
const Wan30AiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Wan30AiVideoGenerator} />
			<LandingTemplate
				data={landingWan30AiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default Wan30AiVideoGenerator;
